document.addEventListener('DOMContentLoaded', function () {
  const fmt = n => n.toFixed(2).replace('.', ',') + ' €';

  document.querySelectorAll('.tier-price').forEach(el => {
    let tp;
    try { tp = JSON.parse(el.dataset.tierPrices); } catch (e) { console.error('tier_prices parse failed', e); return; }

    const tier = el.dataset.serverTier || 'default';
    const basePrice = tp[tier] ?? tp.default;
    let price = basePrice;

    const eb = tp[tier === 'default' ? 'public_eb' : tier + '_eb'];
    const now = new Date();
    if (eb && (!eb.starts || now >= new Date(eb.starts)) && now <= new Date(eb.ends)) {
      price = Math.min(eb.price, price);
    }

    if (price < basePrice) {
      el.innerHTML = `<span class="tier-price__value">${fmt(price)}</span> <span class="old">${fmt(tp.default)}</span>`;
    }
  });
});